import { Navigate, Route, Routes } from 'react-router-dom';
import LoginForm from './login/loginForm';
import Layout from './components/layout/layout';
import Agenda from './agenda/agendaRouter';
import PatientList from './patient/list/patient-list';
import Home from './home/homeRouter'
import Appointment from './appointment/appointment';
import PatientForm from './patient/form/patient-form';
import './App.css';
import ExpiredSession from './expired-session/expiredSession';
import TreatmentToPrint from './patient/form/treatments/treatmentToPrint';
import PrescriptionToPrint from './patient/form/prescriptions/prescriptionToPrint';
import AttestedToPrint from './patient/form/attested/attestedToPrint';
import ChangePassword from './change-password/changePassword';
import DentistList from './dentist/dentist-list/dentistListRouter';
import PrintSettings from './print-settings/printSettings';
import TermsList from './terms/termsList';
import NotificationsList from './notifications/notificationsList';
import InterestedClientPage from './trial/InterestedClientPage';


export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />

      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/home" element={
        <Layout>
          <Home />
        </Layout>
      } />

      <Route path="/agenda" element={
        <Layout>
          <Agenda />
        </Layout>
      } />

      <Route path="/patient-list" element={
        <Layout>
          <PatientList />
        </Layout>
      } />

      <Route path="/patient-form/:patientId?" element={
        <Layout>
          <PatientForm />
        </Layout>
      } />

      <Route path="/expired-session" element={<ExpiredSession />} />

      <Route path="/appointment/:appointmentId?" element={
        <Layout>
          <Appointment />
        </Layout>
      } />

      <Route path="/dentist" element={
        <Layout>
          <DentistList />
        </Layout>
      } />

      <Route path="/print-settings" element={
        <Layout>
          <PrintSettings />
        </Layout>
      } />

      <Route path="/treatment-to-print/:treatmentId" element={
        <TreatmentToPrint />
      } />

      <Route path="/prescription-to-print/:patientId/:prescriptionId" element={
        <PrescriptionToPrint />
      } />

      <Route path="/attested-to-print/:patientId/:attestedId" element={
        <AttestedToPrint />
      } />

      <Route path="/change-password" element={
        <Layout>
          <ChangePassword />
        </Layout>
      } />

      <Route path="/terms" element={
        <Layout>
          <TermsList />
        </Layout>
      } />

      <Route path="/settings/notifications" element={
        <Layout>
          <NotificationsList />
        </Layout>
      } />

      <Route path="/register" element={
        <InterestedClientPage />} />

    </Routes >
  );
}